import { ApolloClient } from '@apollo/client'
import { ADVISOR_BOARD } from '@src/gql/queries/AdvisorBoard'

/**
 * After a $299 team entitlement is granted, force a network re-read of advisorBoard.
 *
 * `advisorBoard` lazily provisions team seats (syncTeamEngagementsForUser) on the server.
 * Apollo often still holds a pre-purchase cache that only contains Wil.ai, which makes
 * Ask Advisors / the left nav look empty of humans until a hard reload.
 */
export async function refreshAdvisorBoard(client: ApolloClient) {
  await client.query({
    query: ADVISOR_BOARD,
    fetchPolicy: 'network-only',
  })
}
